import { Fragment, h, render } from "preact";
import { useEffect, useState, useRef } from "preact/hooks";
import { isColor, findColorOptionName } from "../helpers/colors";
import SwatchImage from "../main-product/swatchImage";

const ProductColorCard = ({ data, gallery }) => {
  // Product Data
  const product = data;
  const variants = product.variants.edges;
  const productImages = product?.images?.edges.map((edge) => edge.node);
  const variantsImages = variants.map((edge) => edge?.node?.image);
  const images = productImages.filter((i) => {
    return !variantsImages.find((v) => {
      return v.src === i.src;
    });
  });

  // Product Options
  const colors = product.options.filter((o) => {
    return isColor(o.name);
  })[0];
  const options = product?.options?.filter(
    (option) => !isColor(option.name) && option.name != "Title",
  );

  const colorOptionName = findColorOptionName(product?.options);

  // Set Initial Variant Options
  let variantOptions = product?.options.map((edge) => ({
    [edge?.name]: variants[0]?.node?.selectedOptions.find(
      (element) => element.name == [edge?.name],
    ).value,
  }));

  let swatchCount = null;
  try {
    swatchCount =
      colors?.values?.length > 3 ? colors?.values?.length - 3 : null;
  } catch (error) {
    console.log("No Colors available");
  }

  const [variant, setVariant] = useState(variants[0].node);
  const [selectedOptions, setSelectedOptions] = useState(variantOptions);
  const [variantImages, setVariantImages] = useState(images);

  const handleVariantChange = (option, val) => {
    const selectedOption = selectedOptions.map((o) => {
      if (Object.keys(o) == option) {
        return {
          ...o,
          [option]: val,
        };
      }
      return o;
    });

    let selectedVariant = variants.filter((v) => {
      let vo = product?.options.map((edge) => ({
        [edge?.name]: v?.node?.selectedOptions.find(
          (element) => element.name == [edge?.name],
        ).value,
      }));

      return JSON.stringify(vo) === JSON.stringify(selectedOption);
    });

    setVariant(selectedVariant[0].node);
    return setSelectedOptions(selectedOption);
  };

  const handleVariantActive = (name, val) => {
    let vo = Object.assign({}, ...selectedOptions);
    return vo[name] == val ? "--active" : "";
  };

  useEffect(() => {
    let vi = variant?.image.src;
    vi = vi && productImages.filter((i) => vi.includes(i.src));
    vi = vi.length > 0 ? vi : productImages;
    let vis = images.filter((val) => !vi.includes(val));
    vis = vis.length > 0 ? vi.concat(vis) : productImages;
    return setVariantImages(vis);
  }, [variant]);

  return (
    <div className={`product-color-card fade color-feature`}>
      {/* Creating a temp url till the password is lifted */}
      {/* Will replace with product.onlineStoreUrl */}
      <div className="product-color-card__images">
        {/* Product Card Primary Image */}
        <a
          href={`/products/${data?.handle}`}
          aria-label={product.title}
          className={`product-color-card__image ${
            variantImages.length > 1 && gallery ? "primary" : ""
          }`}
        ></a>
        <img
          src={getSizedImageUrl(variantImages[0]?.src, "grande")}
          loading="lazy"
          alt={product.title}
        />
      </div>

      {/* Product Card Content */}
      <div className="product-color-card__content">
        {/* Product Card Swatches */}
        {swatchCount > 0 && (
          <div className="product-color-card__swatches color-feature">
            {colors?.values?.length &&
              colors?.values?.map((c, i) => (
                <div className="swatch-container">
                  <button
                    aria-label={c}
                    type="button"
                    onClick={() => {
                      handleVariantChange(colorOptionName, c);
                    }}
                    className={`product-color-card__swatch product-color-card__swatch${handleVariantActive(
                      colorOptionName,
                      c,
                    )} color-feature`}
                  >
                    <SwatchImage
                      product={product}
                      handle={data?.handle}
                      optionValue={c}
                    />
                  </button>
                  <span
                    className={`button-text product-color-card__swatch-name product-color-card__swatch-name${handleVariantActive(
                      colorOptionName,
                      c,
                    )}`}
                  >
                    {c}
                  </span>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductColorCard;
